import React, {Component} from "react";
import {NavLink} from 'react-router-dom'
import {getDateFormat} from "../../../../../utils/functions";
import * as func from "../../../../../utils/functions";
import * as hooks from "../../../../../utils/hooks";
import JournalItem from "../../../../journal/front/list/Jitem";
import {BASE_PATH} from "../../../../../wpconfig";
import Loading from "../../../../etc/loading";

class DMajorArticle extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isInit: false,
			param: {
				'current_page': 1,
				'record_per_page': 30,
				'ks': '',
				'sub_ks': '',
				'jcr_category': [],
				'kci_category': [],
				'scopus_category': [],
				'publisher': [],
				'registered_db_name': [],
				'registered_db_year': [],
				'journal_ranking': [],
				'dept_id': [this.props.record.category_id],
				'order_by': 'ranking',
				'order': 'asc',
				'journal_status': [],
				'date_type': 'input_date',
				'in_date_start': '',
				'in_date_end': '',
			},
			records: [],
			show : false
		}
	}

	componentDidMount() {
		this.getList();
	}

	getList() {
		func.getData("journals", this.state.param).then((response) => {
			this.setState({
				isInit: true,
			})
			this.setState({records: response.records})
		});
	}

	onShowHideClick = () => {
		this.setState({
			show: !this.state.show
		})
	}

	render() {
		const records = this.state.records;

		let buttonClass = "icon icon-size-24 icon-plus-black align-top mr-2"
		if(this.state.show)
			buttonClass = "icon icon-size-24 icon-minus-black align-top mr-2"

		return (
			<>
				{this.state.isInit > 0 ?
				<div className="mt-65">
					<div className="d-flex justify-content-between align-items-center mb-px-26">
						<div className="d-flex align-items-center">
							<h3 className="con-title">학과 주요 학술지</h3>
						</div>
					</div>
					<div>
						<div className="line-list-group">
							{records.map((record, index) => {
								if (index > 5 && !this.state.show)
									return ''
								return (
									<JournalItem key={index} record={record}/>
								)
							})}
						</div>
					</div>
					{records.length > 5 &&
					<div className="mt-4">
						<div className="text-center">
							<div className="mt-4">
								<div className="text-center">
									<button className="btn btn-outline-gray btn-lg" onClick={this.onShowHideClick}>
										<span className={buttonClass}/>
										<strong>{this.state.show ? '닫기' : '더보기'}</strong></button>
								</div>
							</div>
						</div>
					</div>
					}
				</div> : <div className="mt-65"><Loading /></div>
				}
			</>
		)
	}
};

export default DMajorArticle;
